import { React, useCallback, useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import Labels from "../../../services/apiLabels";
import { POST } from "../../../constant/apiMethods";
import "./style.css";
import { HiOutlineShieldCheck, HiOutlineGlobeAlt, HiOutlineLightningBolt, HiOutlineBadgeCheck } from "react-icons/hi";
import { useHistory } from "react-router-dom";
import {
  CAR_REG_NUMBER,
  SELL_MY_CAR_STEPS,
  TOASTER_SHOW,
  toaster_w,
} from "../../../constant";
import { scrollTop } from "../../../utils/window";
import {
  DEFAULT_PLATE_COUNTRY,
  PLATE_COUNTRIES,
  REG_INPUT_MAX_LENGTH,
  detectPlateCountry,
  formatRegForApi,
  formatRegForDisplay,
  getDetectedCountryHint,
  getPlatePlaceholder,
  getRegValidationError,
  normalizeRegNumber,
  sanitizeRegInput,
  suggestPlateCountry,
} from "../../../utils/plateCountry";
import { AiFillCaretRight, AiOutlineNumber } from "react-icons/ai";
import { Spinner } from "react-bootstrap";
import { useContext } from "react";
import FeedbackContext from "../../../context/cmscontext";
import ValuationAuthModal from "../../../components/ValuationAuthModal";
import PlateCountryBadge from "../../../components/PlateCountryBadge";
import { get as getLocalStorage } from "../../../services/localStorage";

const HERO_IMAGE = "/images/hero-cinematic-luxury.jpg";
const HERO_IMAGE_FALLBACK = "/images/hero-cinematic-drive.jpg";

/** Logged in = Redux auth token, or persisted token in localStorage. */
function isUserLoggedIn(auth) {
  if (auth?.token) return true;
  try {
    const stored = getLocalStorage({ key: "auth" });
    return Boolean(stored?.token);
  } catch (e) {
    return false;
  }
}

function Banner(props) {
  const {
    style,
    auth,
    car_reg_num,
    sellMyCar,
    setbrand,
    setmodel,
    setfuelType,
    setyear,
    sellMyCar_new,
    setvariant,
    setreg_number,
    setplate_country,
    resetValuationInputs,
    toasterShow,
  } = props;

  const brand = props.sellMyCar.step1.brand.current;
  const model = props.sellMyCar.step1.model;
  const fuel_type = props.sellMyCar.step1.fuel_type;
  const year = props.sellMyCar.step1.year;
  const variant = props.sellMyCar.step1.variant;

  const { feedback } = useContext(FeedbackContext);
  const home_page = feedback.home_page;
  const history = useHistory();

  const emptyStepField = {
    fetching: false,
    data: [],
    isSelected: false,
    current: {},
  };

  const [regunm, setregunm] = useState("");
  const [plateCountry, setPlateCountry] = useState(DEFAULT_PLATE_COUNTRY);
  const [detectedHint, setDetectedHint] = useState("");
  const [regError, setRegError] = useState("");
  const [isCheckingReg, setIsCheckingReg] = useState(false);
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const activeRegRef = useRef("");
  const pendingRegRef = useRef("");
  const pendingCountryRef = useRef(DEFAULT_PLATE_COUNTRY);
  const authHandledRef = useRef(false);
  const countryTouchedRef = useRef(false);
  // Only navigate to /evaluation for a lookup started in this session —
  // leftover car_reg_ in Redux must not bounce Home → Evaluation.
  const pendingLookupRef = useRef(false);

  const heroImage = HERO_IMAGE;

  const startValuation = useCallback(
    (reg, country = plateCountry) => {
      const normalized = normalizeRegNumber(reg);
      const error = getRegValidationError(normalized, country);
      if (error || isCheckingReg) {
        if (error) setRegError(error);
        return;
      }
      const Reg_Num = formatRegForApi(reg, country);
      setRegError("");
      activeRegRef.current = Reg_Num;
      pendingCountryRef.current = country;
      pendingLookupRef.current = true;
      setregunm(formatRegForDisplay(reg, country));
      setIsCheckingReg(true);
      resetValuationInputs();
      if (typeof setplate_country === "function") {
        setplate_country(country);
      }
      car_reg_num({ Reg_Num, country });
    },
    [car_reg_num, isCheckingReg, plateCountry, resetValuationInputs, setplate_country]
  );

  const handleAuthSuccess = useCallback(() => {
    if (authHandledRef.current) return;
    authHandledRef.current = true;
    setAuthModalOpen(false);
    const country = pendingCountryRef.current || plateCountry;
    const pending = pendingRegRef.current || regunm;
    if (getRegValidationError(pending, country)) return;
    pendingRegRef.current = "";
    startValuation(pending, country);
  }, [regunm, plateCountry, startValuation]);

  useEffect(() => {
    if (!pendingLookupRef.current) return;

    if (sellMyCar_new?.brands) {
      pendingLookupRef.current = false;
      setIsCheckingReg(false);
      if (sellMyCar_new.api_data?.vehicle) {
        sellMyCar_new.brands.color = sellMyCar_new.api_data.vehicle.colour;
      }

      const carReg = (activeRegRef.current || regunm || "").toUpperCase();
      setbrand({ ...brand, isSelected: true, current: sellMyCar_new.brands });
      setmodel({ ...model, isSelected: true, current: sellMyCar_new.model_name });
      setfuelType({ ...fuel_type, isSelected: true, current: sellMyCar_new.fuel_type });
      setyear({ ...year, isSelected: true, current: sellMyCar_new.year });
      setvariant({ ...variant, isSelected: true, current: sellMyCar_new.variant });

      setreg_number(carReg);
      if (typeof setplate_country === "function") {
        setplate_country(pendingCountryRef.current || plateCountry);
      }
      history.push({
        pathname: "/evaluation",
        state: {
          Car_Reg_N: carReg,
          plateCountry: pendingCountryRef.current || plateCountry,
        },
      });
      scrollTop();
      return;
    }

    if (sellMyCar_new?.status === "error") {
      pendingLookupRef.current = false;
      setIsCheckingReg(false);
      const carReg = (activeRegRef.current || regunm || "").toUpperCase();
      setbrand({ ...emptyStepField });
      setmodel({ ...emptyStepField });
      setfuelType({ ...emptyStepField });
      setyear({ ...emptyStepField });
      setvariant({ ...emptyStepField });
      setreg_number(carReg);
      if (typeof setplate_country === "function") {
        setplate_country(pendingCountryRef.current || plateCountry);
      }
      history.push({
        pathname: "/evaluation",
        state: {
          Car_Reg_N: carReg,
          plateCountry: pendingCountryRef.current || plateCountry,
          manualVehicle: true,
        },
      });
      scrollTop();
    }
  }, [sellMyCar_new]);

  useEffect(() => {
    if (!isCheckingReg) return undefined;
    const timeout = window.setTimeout(() => {
      pendingLookupRef.current = false;
      setIsCheckingReg(false);
    }, 20000);
    return () => window.clearTimeout(timeout);
  }, [isCheckingReg]);

  const car_value = (event) => {
    event.preventDefault();
    if (isCheckingReg) return;
    const normalized = normalizeRegNumber(regunm);
    setregunm(formatRegForDisplay(regunm, plateCountry));
    const error = getRegValidationError(normalized, plateCountry);
    if (error) {
      setRegError(error);
      return;
    }
    setRegError("");
    const Reg_Num = formatRegForApi(regunm, plateCountry);

    if (!isUserLoggedIn(auth)) {
      pendingRegRef.current = Reg_Num;
      pendingCountryRef.current = plateCountry;
      authHandledRef.current = false;
      toasterShow({
        show: true,
        autoHide: true,
        type: toaster_w,
        description:
          "Please log in or sign up to get your vehicle valuation.",
      });
      setAuthModalOpen(true);
      return;
    }

    startValuation(Reg_Num, plateCountry);
  };

  const onPlateCountryChange = (code) => {
    countryTouchedRef.current = true;
    setPlateCountry(code);
    setRegError("");
    if (normalizeRegNumber(regunm)) {
      setregunm(formatRegForDisplay(regunm, code));
      setDetectedHint(getDetectedCountryHint(regunm, code));
    } else {
      setDetectedHint("");
    }
  };

  const onRegInputChange = (e) => {
    const next = sanitizeRegInput(e.target.value).slice(0, REG_INPUT_MAX_LENGTH);
    const normalized = normalizeRegNumber(next);
    setDetectedHint("");
    setregunm(next);
    if (regError) setRegError("");

    if (!countryTouchedRef.current) {
      const suggested = suggestPlateCountry(normalized);
      if (suggested && suggested !== plateCountry) {
        setPlateCountry(suggested);
      }
    }
  };

  const onRegInputBlur = () => {
    const normalized = normalizeRegNumber(regunm);
    if (!normalized) {
      setDetectedHint("");
      setRegError(getRegValidationError("", plateCountry));
      return;
    }

    let country = plateCountry;
    const detected = detectPlateCountry(normalized);
    // Auto-select IE/UK only if user hasn't manually chosen a country
    if (
      !countryTouchedRef.current &&
      detected &&
      detected !== "OTHER" &&
      detected !== plateCountry
    ) {
      country = detected;
      setPlateCountry(detected);
    }

    const formatted = formatRegForDisplay(regunm, country);
    setregunm(formatted);

    const error = getRegValidationError(formatted, country);
    if (error) {
      setRegError(error);
      setDetectedHint("");
      return;
    }

    setRegError("");
    setDetectedHint(getDetectedCountryHint(formatted, country));
  };

  const benefits = [
    home_page.baner_sub_heading1,
    home_page.baner_sub_heading2,
    home_page.baner_sub_heading3,
  ];

  const trustItems = [
    { Icon: HiOutlineGlobeAlt, text: "Worldwide reach" },
    { Icon: HiOutlineLightningBolt, text: "Instant quotes" },
    { Icon: HiOutlineShieldCheck, text: "Secure transactions" },
    { Icon: HiOutlineBadgeCheck, text: "Verified dealers" },
  ];

  const isRegValid = !getRegValidationError(regunm, plateCountry);
  const canSubmitValuation = isRegValid && !isCheckingReg;

  return (
    <section className="pi-hero banner_main_cont" style={{ width: style?.width || "100%" }}>
      <div className="pi-hero__media" aria-hidden>
        <div
          className="pi-hero__bg banner_background_image"
          style={{ backgroundImage: `url(${heroImage}), url(${HERO_IMAGE_FALLBACK})` }}
        />
        <div className="pi-hero__orb pi-hero__orb--a" />
        <div className="pi-hero__orb pi-hero__orb--b" />
        <div className="pi-hero__beam" />
        <div className="pi-hero__shade" />
        <div className="pi-hero__grain" />
        <div className="pi-hero__glow" />
      </div>

      <div className="pi-hero__body pi-hero__body--animate">
        <div className="pi-hero__grid">
          <div className="pi-hero__intro landingmain_banner_left_cont">
            <span className="pi-hero__eyebrow">AutoTrade Port</span>
            <h1 className="pi-hero__title banner_heading">{home_page.baner_heading}</h1>
            <p className="pi-hero__subtitle">
              Buy, sell and trade new &amp; used vehicles with verified dealers and instant valuations.
            </p>
            <ul className="pi-hero__features">
              {benefits.map((text) => (
                <li key={text}>
                  <HiOutlineShieldCheck size={20} aria-hidden />
                  <span>{text}</span>
                </li>
              ))}
            </ul>
          </div>

          <aside className="pi-hero__aside landingmain_banner_right_cont">
            <div className="pi-hero-card pi-valuation reg_car_wrap" id="sell-car">
              <div className="pi-hero-card__top">
                <span className="pi-hero-card__badge">Free valuation</span>
                <h2 className="pi-hero-card__title main_ttt">Get your vehicle price</h2>
                <p className="pi-hero-card__desc">{home_page.car_reg_text}</p>
              </div>
              <form onSubmit={car_value} autoComplete="off" className="pi-hero-card__form">
                <div
                  className="pi-hero-card__countries"
                  role="radiogroup"
                  aria-label="Plate country"
                >
                  {PLATE_COUNTRIES.filter((c) => c.code !== "OTHER").map(
                    ({ code, label }) => (
                    <button
                      key={code}
                      type="button"
                      role="radio"
                      aria-label={label}
                      aria-checked={plateCountry === code}
                      className={
                        plateCountry === code
                          ? "pi-hero-card__country is-active"
                          : "pi-hero-card__country"
                      }
                      onClick={() => onPlateCountryChange(code)}
                    >
                      <PlateCountryBadge code={code} />
                    </button>
                    )
                  )}
                </div>
                <label className="pi-hero-card__label" htmlFor="hero-reg-input">
                  Registration number
                </label>
                <div
                  className={`pi-hero-card__field${
                    regError ? " is-invalid" : ""
                  }`}
                >
                  <AiOutlineNumber size={18} className="pi-hero-card__field-icon" aria-hidden />
                  <input
                    id="hero-reg-input"
                    className="pi-hero-card__input reg_input pi-valuation__input"
                    required
                    type="text"
                    value={regunm}
                    onChange={onRegInputChange}
                    onBlur={onRegInputBlur}
                    placeholder={
                      getPlatePlaceholder(plateCountry) ||
                      home_page.car_reg_placeholder
                    }
                    maxLength={REG_INPUT_MAX_LENGTH}
                    aria-label="Registration or plate number"
                    aria-invalid={Boolean(regError)}
                    aria-describedby={
                      [
                        regError ? "hero-reg-error" : null,
                        detectedHint ? "hero-reg-country-hint" : null,
                      ]
                        .filter(Boolean)
                        .join(" ") || undefined
                    }
                  />
                </div>
                {regError ? (
                  <p
                    id="hero-reg-error"
                    className="pi-hero-card__error"
                    role="alert"
                  >
                    {regError}
                  </p>
                ) : null}
                {!regError && detectedHint ? (
                  <p
                    id="hero-reg-country-hint"
                    className="pi-hero-card__country-hint"
                    role="status"
                  >
                    {detectedHint}
                  </p>
                ) : null}
                <button
                  type="submit"
                  className="pi-hero-card__submit value_btn pi-valuation__btn"
                  name="CTAButton"
                  disabled={!canSubmitValuation}
                  aria-disabled={!canSubmitValuation}
                >
                  {isCheckingReg ? (
                    <>
                      {home_page.car_reg_button_loding_text}
                      <Spinner animation="border" variant="light" size="sm" />
                    </>
                  ) : (
                    <>
                      {home_page.car_reg_button_text}
                      <AiFillCaretRight size={18} />
                    </>
                  )}
                </button>
                <p className="pi-hero-card__note">No obligation · Results in seconds</p>
              </form>
            </div>
          </aside>
        </div>
      </div>

      <div className="pi-hero__bar">
        <div className="pi-hero__bar-dock">
          <div className="pi-hero__bar-inner">
            {trustItems.map(({ Icon, text }) => (
              <div key={text} className="pi-hero__bar-cell">
                <span className="pi-hero__bar-icon" aria-hidden>
                  <Icon size={18} />
                </span>
                <span className="pi-hero__bar-label">{text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ValuationAuthModal
        open={authModalOpen}
        onClose={() => setAuthModalOpen(false)}
        onAuthSuccess={handleAuthSuccess}
      />
    </section>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  car_color: state.sellMyCar.car_color_data,
  sellMyCar_new: state.sellMyCar.car_reg_,
  car_reg_loading: state.sellMyCar.car_reg_loading,
  fetchingBrands: state.sellMyCar.fetchingBrands,
  brands: state.sellMyCar.brands,
  showInterest: state.showInterest,
  sellMyCar: state.sellMyCar,
});

const mapDispatchToProps = (dispatch) => ({
  car_reg_num: (data) =>
    dispatch({
      type: CAR_REG_NUMBER,
      payload: {
        type: CAR_REG_NUMBER,
        method: POST,
        label: Labels.car_reg_chk,
        hideOverlayLoader: true,
        data,
      },
    }),
  setbrand: (data) =>
    dispatch({ type: SELL_MY_CAR_STEPS, payload: { type: "brand", data } }),
  setmodel: (data) =>
    dispatch({ type: SELL_MY_CAR_STEPS, payload: { type: "model", data } }),
  setfuelType: (data) =>
    dispatch({ type: SELL_MY_CAR_STEPS, payload: { type: "fuel_type", data } }),
  setyear: (data) =>
    dispatch({ type: SELL_MY_CAR_STEPS, payload: { type: "year", data } }),
  setvariant: (data) =>
    dispatch({ type: SELL_MY_CAR_STEPS, payload: { type: "variant", data } }),
  setreg_number: (data) =>
    dispatch({ type: SELL_MY_CAR_STEPS, payload: { type: "reg_number", data } }),
  setplate_country: (data) =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: { type: "plate_country", data },
    }),
  resetValuationInputs: () =>
    dispatch({
      type: SELL_MY_CAR_STEPS,
      payload: { type: "reset_valuation_inputs" },
    }),
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: { ...data },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Banner);
